<template>
  <div class="mobile-dashboard-others">
    <b-row class="mt-1">
      <b-col cols="6">
        <div class="others-item dashboard-card" @click="$router.push({ name: 'kits-list' })">
          <b-img
            :src="'https://api.illustrativedna.com/assets/icons/mobile/'+$store.state.appConfig.layout.skin+'_my_kits.svg'"
          />
          <div class="text g25-text mobile-dashboard-item-text">My Kits</div>
        </div>
      </b-col>
      <b-col cols="6">
        <div class="others-item dashboard-card" @click="$router.push({ name: 'order-list' })">
          <b-img
            :src="'https://api.illustrativedna.com/assets/icons/mobile/'+$store.state.appConfig.layout.skin+'_my_orders.svg'"
          />
          <div class="text g25-text mobile-dashboard-item-text">My Orders</div>
        </div>
      </b-col>
      <b-col cols="12 mt-2">
        <div class="others-item dashboard-card d-flex align-items-center justify-content-start" @click="$router.push({ name: 'ticket-list' })">
          <b-img
            :src="'https://api.illustrativedna.com/assets/icons/mobile/'+$store.state.appConfig.layout.skin+'_my_tickets.svg'"
          />
          <div class="text main-textml-3 ml-3">My Tickets</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    theme() {
      return this.$store.state.appConfig.layout.skin === 'light' ? 'active' : 'normal';
    },
  },
  created() {

  },
}
</script>

<style scoped lang="scss">
.mobile-dashboard-others h3 {
  color: var(--lab-black);
  font-weight: 600;
}

.mobile-dashboard-item-text {
  margin-top:7px;
}

.others-item {
  text-align: center;
  padding: 10px;
}

.others-item img {
  width: 50px !important;
  height: 50px !important;
}

.others-item .text {
  font-size: 1rem;
  font-weight: bold;
  color: var(--lab-black);
}

.dark-layout {
  .mobile-dashboard-others h3 {
    color: var(--lab-main-color);
  }
}
</style>
